import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import "./colorfield.css";
import $f9TgH$colorfield_cssmjs from "./colorfield_css.mjs";
import {TextFieldBase as $b312f2102feb9487$export$d22444a338b6e3c2} from "../textfield/TextFieldBase.mjs";
import {useFormProps as $c29c48d4ef19ffc4$export$a6b5be5c6b451665} from "../form/Form.mjs";
import {useProviderProps as $71dfb0e0358a12de$export$521c373ccc32c300} from "../provider/Provider.mjs";
import {useColorChannelField as $f9TgH$useColorChannelField, useColorField as $f9TgH$useColorField} from "react-aria/useColorField";
import {ColorFieldContext as $f9TgH$ColorFieldContext} from "react-aria-components/ColorField";
import $f9TgH$react, {useRef as $f9TgH$useRef, useEffect as $f9TgH$useEffect} from "react";
import {useColorChannelFieldState as $f9TgH$useColorChannelFieldState, useColorFieldState as $f9TgH$useColorFieldState} from "react-stately/useColorFieldState";
import {useContextProps as $f9TgH$useContextProps} from "react-aria-components/slots";
import {useLocale as $f9TgH$useLocale} from "react-aria/I18nProvider";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 










const $41f1a8db81de171a$export$b865d4358897bb17 = /*#__PURE__*/ (0, $f9TgH$react).forwardRef(function ColorField(props, ref) {
    props = (0, $71dfb0e0358a12de$export$521c373ccc32c300)(props);
    props = (0, $c29c48d4ef19ffc4$export$a6b5be5c6b451665)(props);
    [props] = (0, $f9TgH$useContextProps)(props, null, (0, $f9TgH$ColorFieldContext));
    let hasWarned = (0, $f9TgH$useRef)(false);
    (0, $f9TgH$useEffect)(()=>{
        if (props.placeholder && !hasWarned.current && process.env.NODE_ENV !== 'production') {
            console.warn('Placeholders are deprecated due to accessibility issues. Please use help text instead. See the docs for details: https://react-spectrum.adobe.com/react-spectrum/ColorField.html#help-text');
            hasWarned.current = true;
        }
    }, [
        props.placeholder
    ]);
    if (props.channel) return /*#__PURE__*/ (0, $f9TgH$react).createElement($41f1a8db81de171a$var$ColorChannelField, {
        ...props,
        channel: props.channel,
        forwardedRef: ref
    });
    else return /*#__PURE__*/ (0, $f9TgH$react).createElement($41f1a8db81de171a$var$HexColorField, {
        ...props,
        forwardedRef: ref
    });
});
function $41f1a8db81de171a$var$ColorChannelField(props) {
    let { value: // These disabled props are handled by the state hook
    value, defaultValue: defaultValue, onChange: onChange, validate: validate, forwardedRef: forwardedRef, ...otherProps } = props;
    let { locale: locale } = (0, $f9TgH$useLocale)();
    let state = (0, $f9TgH$useColorChannelFieldState)({
        ...props,
        locale: locale
    });
    let inputRef = (0, $f9TgH$useRef)(null);
    let result = (0, $f9TgH$useColorChannelField)(otherProps, state, inputRef);
    return /*#__PURE__*/ (0, $f9TgH$react).createElement((0, $f9TgH$react).Fragment, null, /*#__PURE__*/ (0, $f9TgH$react).createElement((0, $b312f2102feb9487$export$d22444a338b6e3c2), {
        ...otherProps,
        ref: forwardedRef,
        inputRef: inputRef,
        ...result,
        inputClassName: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($f9TgH$colorfield_cssmjs))), 'react-spectrum-ColorField-input')
    }), props.name && /*#__PURE__*/ (0, $f9TgH$react).createElement("input", {
        type: "hidden",
        name: props.name,
        form: props.form,
        value: isNaN(state.numberValue) ? '' : state.numberValue
    }));
}
function $41f1a8db81de171a$var$HexColorField(props) {
    let { value: // These disabled props are handled by the state hook
    value, defaultValue: defaultValue, onChange: onChange, forwardedRef: forwardedRef, ...otherProps } = props;
    let state = (0, $f9TgH$useColorFieldState)(props);
    let inputRef = (0, $f9TgH$useRef)(null);
    let result = (0, $f9TgH$useColorField)(otherProps, state, inputRef);
    return /*#__PURE__*/ (0, $f9TgH$react).createElement((0, $b312f2102feb9487$export$d22444a338b6e3c2), {
        ...otherProps,
        ref: forwardedRef,
        inputRef: inputRef,
        ...result,
        inputClassName: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($f9TgH$colorfield_cssmjs))), 'react-spectrum-ColorField-input')
    });
}


export {$41f1a8db81de171a$export$b865d4358897bb17 as ColorField};
//# sourceMappingURL=ColorField.mjs.map
